export default __webpack_public_path__ + "static/media/logo.6f38e571.jpg";